'use strict';

import MetadataTitleAbstract from './metadata.title.abstract';

/**
 * Title
 * @param  {*} template
 */
class Title extends MetadataTitleAbstract  {
	constructor(template) {
		super(template);

		// Set type
		this.type = 'title';
	}
}

export default Title;